export const SHAREABLE_FIELDS_ARRAY = [
  { key: "title", fieldName: "Title*" },
  { key: "description", fieldName: "Description" },
];
